import { AuthenticationManager } from "@core/managers/authentication.manager";
import { StorageManager } from "@core/managers/storage.manager";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import { META_LAYOUT, META_ALLOW_ANONYMOUS } from "@core/constants";

import { ETAB_LAYOUTS, ETAB_ROUTES, FUNNEL_SIGNUP_INFO, FUNNEL_SIGNUP_INFO_ALT, META_STEPS_DEFINITIONS, META_BACK_ROUTE } from "@etab/config";
import { GETTER_SIGNUP_GET } from "@etab/stores/types";
import { useSignupStore } from "@etab/stores/signup";
import { getAccountSteps, accountFirstStep } from "./account-steps";
import { getInfoStepsFull, getInfoStepsAlt } from "./info-steps";
import { RouterView } from "vue-router";

import SignupRoot from "./Signup.root.vue";
import WelcomePage from "./Welcome.page.vue";
import SuccessPage from "./Success.page.vue";

const getStepsMeta = (stepsDefinitions) => {
  // only exports the necessary bits to allow for step layout to operate
  return stepsDefinitions.map((step) => ({
    path: step.path,
    name: step.name,
    meta: step.meta,
  }));
};

export default function () {
  return [
    {
      path: ETAB_ROUTES.signup.root.path,
      name: ETAB_ROUTES.signup.root.name,
      component: SignupRoot,
      meta: { [META_ALLOW_ANONYMOUS]: true },
      redirect: { name: ETAB_ROUTES.signup.steps.root.name }, // redirect to steps
      beforeEnter: (to, from, next) => {
        const signupStore = useSignupStore();
        DataLayerManager.setData({ page_type: "formulaire", user_connect: "no" }, "etablissement", StorageManager.getUserInfo("etablissement"));
        const signupModel = signupStore[GETTER_SIGNUP_GET];
        if (!signupModel.hasEmail()) {
          // if email is not set, we redirect the user to the signup page
          next({ name: ETAB_ROUTES.auth.signup.name });
        } else {
          next();
        }
      },
      children: [
        {
          // welcome
          path: ETAB_ROUTES.signup.steps.root.path,
          name: ETAB_ROUTES.signup.steps.root.name,
          meta: { [META_ALLOW_ANONYMOUS]: true },
          component: WelcomePage,
        },
        {
          // success
          path: ETAB_ROUTES.signup.steps.success.path,
          name: ETAB_ROUTES.signup.steps.success.name,
          meta: { [META_LAYOUT]: ETAB_LAYOUTS.success },
          component: SuccessPage,
        },
        {
          // main signup
          path: ETAB_ROUTES.signup.steps.main.path,
          name: ETAB_ROUTES.signup.steps.main.name,
          meta: {
            [META_ALLOW_ANONYMOUS]: true,
            [META_LAYOUT]: ETAB_LAYOUTS.steps,
            [META_STEPS_DEFINITIONS]: getStepsMeta(getAccountSteps()),
            [META_BACK_ROUTE]: ETAB_ROUTES.signup.root.name,
          },
          component: RouterView,
          redirect: { name: accountFirstStep },
          children: [...getAccountSteps()],
          beforeEnter: async (to, from, next) => {
            const isAuthenticated = await AuthenticationManager.isUserAuthenticated();
            if (isAuthenticated) {
              // if user is authenticated, he has nothing to do in those steps
              // we prevent the going back to the password step after user creation
              next({ name: ETAB_ROUTES.signup.steps.root.name });
            } else {
              next();
            }
          },
        },
        {
          // additional info
          path: ETAB_ROUTES.signup.steps.info.root.path,
          name: ETAB_ROUTES.signup.steps.info.root.name,
          component: RouterView,
          redirect: () => {
            const signupStore = useSignupStore();
            const signupModel = signupStore[GETTER_SIGNUP_GET];
            if (signupModel.isCHR()) {
              // RG: Etab Creation Additionnal info - if CHR go to number of seats step
              return { name: ETAB_ROUTES.signup.steps.info.full.name };
            }
            // else go to description
            return { name: ETAB_ROUTES.signup.steps.info.alt.name };
          },
          children: [
            {
              // additional info full
              path: ETAB_ROUTES.signup.steps.info.full.path,
              name: ETAB_ROUTES.signup.steps.info.full.name,
              meta: {
                [META_LAYOUT]: ETAB_LAYOUTS.steps,
                [META_STEPS_DEFINITIONS]: getStepsMeta(getInfoStepsFull()),
                [META_BACK_ROUTE]: ETAB_ROUTES.signup.root.name,
              },
              component: RouterView,
              redirect: { name: FUNNEL_SIGNUP_INFO.seats },
              children: [...getInfoStepsFull()],
            },
            {
              // additional info alternative
              path: ETAB_ROUTES.signup.steps.info.alt.path,
              name: ETAB_ROUTES.signup.steps.info.alt.name,
              meta: {
                [META_ALLOW_ANONYMOUS]: true,
                [META_LAYOUT]: ETAB_LAYOUTS.steps,
                [META_STEPS_DEFINITIONS]: getStepsMeta(getInfoStepsAlt()),
                [META_BACK_ROUTE]: ETAB_ROUTES.signup.root.name,
              },
              component: RouterView,
              redirect: { name: FUNNEL_SIGNUP_INFO_ALT.description },
              children: [...getInfoStepsAlt()],
            },
          ],
        },
      ],
    },
  ];
}
